<template>
  <div v-if="hashtag">
    Showing posts with <span class="text-gold">#{{ hashtag }}</span>
    <a
      href="#"
      class="ml-1"
      title="Remove filter"
      @click.prevent="$emit('remove-hashtag-filter')"
    >
      <b-icon icon="dash" />
    </a>
  </div>
</template>

<script>
export default {
  props: {
    hashtag: {
      type: String,
      default: null,
    },
  },
}
</script>
